import React from 'react'
import * as styled from './AdminDivider.styled'

const Advanced: React.SFC = () => {
  return <styled.Divider>A D V A N C E D</styled.Divider>
}

export default Advanced